import { useState, useEffect } from 'react'
import DashboardHeader from './DashboardHeader'
import WhatsappEngagementCard from './WhatsappEngagementCard'
import ProfileCard from './ProfileCard'
import ApplyWhatsAppApiCard from './ApplyWhatsAppApiCard'
import PurchaseCredits from './PurchaseCredits'
import Preloader from '../preloader';
import { getToken } from '../../function/token';
import domain from '../../../reusecomponent/domain';
import { useDispatch, useSelector } from 'react-redux'
import { setProfile } from '../../../redux/profile_slice'

export default function Maindashboard() {
  const [loder, setLoder] = useState(false);
  const [profileLoading, setProfileLoading] = useState(false);
  const dispatch = useDispatch();
  const userServices = useSelector((state)=> state.serviceStore.value);
  const profile = useSelector((state) => state.profileStore.value);

  // Fetch WhatsApp profile data
  useEffect(() => {
    if (userServices.isconnected && profile === null) {
      fetchWhatsAppProfileData();
    }
  }, [userServices.isconnected]);

  const fetchWhatsAppProfileData = async () => {
    try {
      if(profile !== null){
        return;
      }
      setProfileLoading(true);
      const token = getToken();
      const headers = new Headers();
      headers.append('Authorization', `Bearer ${token}`);
      headers.append('Content-Type', 'application/json');

      const response = await fetch(`${domain()}/whatsapp-profile`, {
        method: 'GET',
        headers: headers,
        redirect: 'follow'
      });

      const result = await response.json();
      
      // Decode base64 data field
      let decodedData = {};
      if (response.ok && result.status) {
        try {
          decodedData = JSON.parse(atob(result.data));
          dispatch(setProfile(decodedData));
        } catch (e) {
          decodedData = {};
        }
      }
      
    } catch (error) {
      console.error('Error fetching WhatsApp profile:', error);
    } finally {
      setProfileLoading(false);
    }
  };


  return (
    <div className="container-fluid dashboard-main m-0 p-0" style={{ background: '#f6f8fa', minHeight: '100vh', width: '100%', boxSizing: 'border-box' }}>
      <DashboardHeader/>
      <div className="dashboard-row" style={{ display: 'flex', gap: 24, width: '100%', boxSizing: 'border-box' }}>
        <div className="dashboard-left-col" style={{ flex: 7, display: 'flex', flexDirection: 'column', gap: 20, minWidth: 0 }}>
          <div className="dashboard-card"><WhatsappEngagementCard /></div>
          <div className="dashboard-card"><ApplyWhatsAppApiCard setLoder={setLoder}/></div>
        </div>
        <div className="dashboard-right-col" style={{ flex: 3, display: 'flex', flexDirection: 'column', gap: 20, minWidth: 0 }}>
          <ProfileCard profileLoading={profileLoading} />
          <div className="dashboard-card">
            <PurchaseCredits/>
          </div>
        </div>
      </div>
      
      {/* Preloader UI Overlay */}
      <Preloader action={loder} />

      <style>{`
        .dashboard-main {
          padding: 8px 12px !important;
          max-width: 100% !important;
          box-sizing: border-box !important;
        }
        @media (min-width: 993px) {
          .dashboard-main {
            padding: 12px 16px !important;
          }
        }
        @media (max-width: 992px) {
          .dashboard-row {
            flex-direction: column !important;
            gap: 16px !important;
          }
          .dashboard-left-col, .dashboard-right-col {
            width: 100% !important;
            flex: none !important;
            gap: 16px !important;
          }
        }
        @media (max-width: 576px) {
          .dashboard-main {
            padding: 4px 6px !important;
          }
          .dashboard-card {
            width: 100% !important;
          }
        }
      `}</style>
    </div>
  )
}
